export default {
  list: {
    title: "商户列表",
    addStore: "新增商户",
    storeName: "商户名称",
  },
  recharge: {
    title: "商户储值",
    amount: "储值金额",
    orderNo: "订单编号",
    rechargeTime: "充值时间",
    currentBalance: "当前账户余额",
  },
  pricing: {
    title: "计价设置",
    deliveryFee: "配送费",
    fixedAmount: "固定金额",
  },
  detail: {
    title: "商户详情",
    balance: "账户余额",
    points: "积分",
    linkedShop: "关联店铺",
    bindChannel: "绑定渠道",
    storeName: "商户名称",
    storeNamePh: "请输入商户名称",
    regTime: "注册时间",
    merchantNo: "商家编号",
    contact: "联系人",
    contactPh: "请输入联系方式",
    tel: "联系电话",
    telPh: "请输入联系方式",
    license: "营业执照",
    address: "商家地址",
    addressPh: "请输入商家地址",
    orderStats: "订单统计",
    totalOrders: "累计订单量",
    totalDeliveryFee: "累计配送费",
    totalRecharge: "累计充值",
    cancelComplaint: "取消/投诉",
  },
};
